import { render, staticRenderFns } from "./applyform.vue?vue&type=template&id=9ef81d96&scoped=true"
import script from "./applyform.vue?vue&type=script&lang=js"
export * from "./applyform.vue?vue&type=script&lang=js"
import style0 from "./applyform.vue?vue&type=style&index=0&id=9ef81d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef81d96",
  null
  
)

export default component.exports